import React from 'react';

export const MoneySendIcon = ({ color = '#475467' }: { color?: string }) => (
    <svg
        width='20'
        height='20'
        viewBox='0 0 20 20'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            d='M7.9165 11.4585C7.9165 12.2669 8.54152 12.9169 9.30818 12.9169H10.8748C11.5415 12.9169 12.0832 12.3502 12.0832 11.6419C12.0832 10.8835 11.7498 10.6085 11.2582 10.4335L8.74984 9.55853C8.25817 9.38353 7.92485 9.11686 7.92485 8.35019C7.92485 7.65019 8.4665 7.0752 9.13316 7.0752H10.6998C11.4665 7.0752 12.0915 7.7252 12.0915 8.53353'
            stroke={color}
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M10 6.25V13.75'
            stroke={color}
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M18.3332 9.99984C18.3332 14.5998 14.5998 18.3332 9.99984 18.3332C5.39984 18.3332 1.6665 14.5998 1.6665 9.99984C1.6665 5.39984 5.39984 1.6665 9.99984 1.6665'
            stroke={color}
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M18.3333 4.99984V1.6665H15'
            stroke={color}
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M14.1665 5.83317L18.3332 1.6665'
            stroke={color}
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </svg>
);
